module.exports = __webpack_public_path__ + "static/media/pass-driver.0e52c23b.png";